export default __webpack_public_path__ + "static/media/home-dentist-icon-03.0be6fcf9.svg";